import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ServiceService } from '../service.service';
import swal from 'sweetalert2';

@Component({
  selector: 'app-payment-result',
  templateUrl: './payment-result.component.html',
  styleUrls: ['./payment-result.component.scss']
})
export class PaymentResultComponent implements OnInit {
  // minutes: number = 5;
  // seconds: number = 0;
  queryObj: any;
  payment_id: any;
  payment_status: any;
  id: any;
  transaction_id: any;
  response_data:any;

  constructor(private route: ActivatedRoute , public router:Router ,private service: ServiceService) { }

  ngOnInit(): void {

    this.route.queryParamMap
    .subscribe((params) => {
      this.queryObj = { ...params.keys, ...params };
      }
    
    );
    //console.log("params :" +JSON.stringify(this.queryObj)) 
    
    var paydata={
        payment_id:this.queryObj.params.payment_id,
        payment_status:this.queryObj.params.payment_status,
        payment_request_id:this.queryObj.params.payment_request_id        
    } 
    
    
    /*
    var paydata = {
      payment_id: 'MOJO3909105N63517615',
      payment_status: 'Credit',
      payment_request_id: 'e76722317ba84c59b5209bf1c5fbe206'
    }
    */
      
    this.service.UpdatePaymentStatus_Portal(paydata)
      .subscribe((data) => {
        this.response_data=data;
        if(this.response_data.code=="200") 
        {
            swal.fire('Thank you.', this.response_data.message, 'success').then((result) => {
              if (result.value) { 
                window.self.close(); 
                // this.startTimer();
                
              }
              this.router.navigate(["/base/patient/join-meeting"]);
            })          
          // this.router.navigate(["/base/patient/quick_consult"]);
        }
        /*
        else
        {      
            swal.fire({
                icon: 'error',        
                text: this.response_data.message,        
                }).then((result) => {
              if (result.value) {         
                  window.self.close();
              }
            })
        } 
        */
        
        //this.router.navigate(["/base/patient/appoinment"]);
      }
        , (error) => {
          
          alert('Payment was not successfully. Please try again.');
          window.self.close();
         
        }
         
    ); 
  }
  
  // startTimer() {
  //   const timerInterval = setInterval(() => {
  //     if (this.seconds > 0) {
  //       this.seconds--;
  //     } else {
  //       if (this.minutes > 0) {
  //         this.minutes--;
  //         this.seconds = 59;
  //       } else {
  //         clearInterval(timerInterval); // Timer expired
  //         swal
  //           .fire({
  //             title: 'Emergency ?',
  //             text: 'Selected Doctor is busy, would you like to change the Doctor?',
  //             icon: 'question',
  //             showCancelButton: true,
  //             confirmButtonText: 'Yes',
  //             cancelButtonText: 'No',
  //           })
  //           .then((result) => {
  //             if (result.value) {
  //               // console.log("User clicked 'Yes'. Navigating to appointment page.");
  //               // this.router.navigateByUrl('/base/patient/appointment');
  //             } else {
  //               // this.router.navigate(['/base/patient/appointment']);
  //             }
  //           });
  //       }
  //     }
  //   }, 1000); // Update timer every 1 second
  // }

}
